import { Cookies } from "react-cookie";
import { COOKIES, DefaultCookieOptions } from "../../constants/misc";

export function removeAuthToken() {
    const cookies = new Cookies();
    cookies.remove(COOKIES.token, DefaultCookieOptions);
    cookies.remove(COOKIES.companyId, DefaultCookieOptions);
    cookies.remove(COOKIES.newUser, DefaultCookieOptions);
}
